import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import AccArrowUp from '../../../images/contract-admin-icons/AccArrowUp';
import AccArrowDown from '../../../images/contract-admin-icons/AccArrowDown';

const Accordion = ({ mainContent, innerChild, hasChild = false }) => {
  const [active, setActive] = useState(false);

  const handleToggle = () => {
    setActive(!active);
  };
  return (
    <Fragment>
      <div className="ent-acc">
        {mainContent}
        {hasChild && (
          <button
            type="button"
            className="ent-acc-toggle"
            key={Math.random()}
            onClick={handleToggle}
          >
            {active ? <AccArrowUp /> : <AccArrowDown />}
          </button>
        )}
      </div>
      {/* {active && <Accordion mainContent={innerChild} hasChild={false} />} */}
      {active && innerChild}
    </Fragment>
  );
};

Accordion.propTypes = {
  hasChild: PropTypes.bool,
  innerChild: PropTypes.element,
  mainContent: PropTypes.element,
};

export default React.memo(Accordion);
